<template>
  <!-- [sc-46314] Cosa c'è su CRM PLUS e come si arriva a parlarne. Il
       principio dell'epic è «START si prova, PLUS si vende»: qui si dice
       chiaro che la personalizzazione passa dall'abbonamento. -->
  <div
    v-if="aperta"
    class="plus-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="CRM PLUS si adatta al tuo modo di lavorare"
    tabindex="-1"
    ref="finestra"
    @keydown.esc="$emit('chiudi')"
  >
    <div class="plus-card">
      <h2 class="plus-titolo">CRM PLUS si adatta al tuo modo di lavorare</h2>
      <p class="plus-testo">
        Con <strong>CRM PLUS</strong> aggiungi le funzioni avanzate che servono
        alla tua azienda.
      </p>

      <ul class="plus-elenco">
        <li v-for="voce in vociPlus" :key="voce.chiave" class="plus-voce">
          <i class="fa-solid" :class="voce.icona" aria-hidden="true"></i>
          <span>
            <strong>{{ voce.etichetta }}</strong>
            {{ voce.testo }}
          </span>
        </li>
      </ul>

      <div class="plus-comandi">
        <button type="button" class="plus-dopo" @click="$emit('chiudi')">
          Non ora
        </button>
        <a
          v-if="linkCall"
          class="plus-call"
          :href="linkCall"
          target="_blank"
          rel="noopener"
          @click="tracciaClic"
        >
          <i class="fa-solid fa-calendar-check" aria-hidden="true"></i>
          Prenota una call
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { VOCE_PLUS_SU_MISURA, VOCI_PLUS } from "@/config/onboarding";
import { linkPrenotaCall } from "@/utilities/abbonamento";
import { EVENTS, trackEvent } from "@/utilities/analytics";

export default {
  name: "PlusCallModal",
  props: {
    aperta: { type: Boolean, default: false },
  },
  emits: ["chiudi"],
  computed: {
    /**
     * Le tre funzioni spente piu' la quarta voce.
     *
     * [revisione 48654] La quarta non e' una funzione da accendere ma
     * l'invito a chiederne una che non c'e', ed e' per questo che nel menu
     * Impostazioni - dove ogni voce ha il suo lucchetto - non compare.
     */
    vociPlus() {
      return [...VOCI_PLUS, VOCE_PLUS_SU_MISURA];
    },
    linkCall() {
      return linkPrenotaCall();
    },
  },
  watch: {
    // All'apertura il fuoco entra nella finestra, così `Esc` chiude davvero e
    // chi naviga da tastiera non resta indietro nel menù.
    aperta(adesso) {
      if (adesso) this.$nextTick(() => this.$refs.finestra?.focus());
    },
  },
  methods: {
    tracciaClic() {
      // Solo un nome tecnico: il filtro di `analytics.js` non lascerebbe
      // passare altro, e non c'è altro da sapere.
      trackEvent(EVENTS.FEATURE_USED, { feature: "book_call" });
    },
  },
};
</script>

<style scoped>
.plus-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.55);
}

.plus-card {
  width: min(520px, 100%);
  background: var(--page-bg, #fff);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.28);
}

.plus-titolo {
  margin: 0 0 10px;
  font-size: 1.2rem;
}

.plus-testo {
  margin: 0 0 16px;
  line-height: 1.5;
}

.plus-elenco {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: grid;
  gap: 12px;
}

.plus-voce {
  display: flex;
  gap: 10px;
  line-height: 1.4;
}

.plus-voce i {
  margin-top: 3px;
  color: var(--brand-on-light, var(--brand));
}

.plus-comandi {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.plus-dopo {
  border: 0;
  background: none;
  color: #64748b;
  text-decoration: underline;
  cursor: pointer;
}

.plus-call {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 8px;
  background: var(--brand);
  color: var(--brand-ink, #fff);
  text-decoration: none;
}
</style>
